import { Coins, TrendingUp } from "lucide-react";
import { TransactionHistoryTable } from "@/bizminer/App/Credits/_components/TransactionHistoryTable.tsx";
import BizminerLayout from "@/bizminer/layouts/app/BizminerLayout";
import type { PagyMetadata } from "@/types";
import type { BizminerInertiaSharedProps } from "@/types/inertia";
import type { BizminerAppCreditsTransaction } from "@/types/serializers";

interface Props extends BizminerInertiaSharedProps {
  credits: number;
  transactions: BizminerAppCreditsTransaction[];
  pagy: PagyMetadata;
}

interface BalanceSummaryCardProps {
  credits: number;
}

const BalanceSummaryCard = ({ credits }: BalanceSummaryCardProps) => {
  return (
    <div className="bg-gradient-to-br from-primary/10 via-primary/5 to-transparent rounded-lg border border-border p-8">
      <div className="flex items-start justify-between">
        <div className="space-y-2">
          <div className="flex items-center gap-2 text-muted-foreground">
            <Coins className="h-5 w-5" />
            <span className="text-sm font-medium">Available Balance</span>
          </div>
          <div className="text-5xl font-bold">{credits}</div>
          <p className="text-sm text-muted-foreground">Credits</p>
        </div>
        <div className="bg-primary/10 p-4 rounded-full">
          <TrendingUp className="h-8 w-8 text-primary" />
        </div>
      </div>
    </div>
  );
};

export default function Index({ credits, transactions, pagy }: Props) {
  return (
    <BizminerLayout>
      <div className="container mx-auto py-8 space-y-8">
        <div>
          <h1 className="text-2xl font-bold">Credits</h1>
          <p className="text-muted-foreground mt-1">
            Manage and track your organization's credit balance
          </p>
        </div>

        <BalanceSummaryCard credits={credits} />
        <TransactionHistoryTable transactions={transactions} pagy={pagy} />
      </div>
    </BizminerLayout>
  );
}
